import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { firstValueFrom } from 'rxjs';
import { first } from 'rxjs/operators';

import { CollectionPickerDialogComponent } from '../dialogs/collection-picker-dialog/collection-picker-dialog.component';
import { Collection, CollectionClassName } from '../models/collection';
import { CollectionItemApiService } from './collection-item-api.service';

@Injectable({
  providedIn: 'root',
})
export class UICollectionService {

  constructor(
    private readonly collectionItemApi: CollectionItemApiService,
    private readonly dialog: MatDialog,
    private readonly snackBarService: MatSnackBar,
  ) {
  }

  async showCollectionPickerHandler(objects: string[], className: CollectionClassName): Promise<boolean> {
    if (!objects.length) {
      return false;
    }
    const ref = this.dialog.open(CollectionPickerDialogComponent, { data: {}, width: '700px', maxHeight: '95vh' });
    const collections: Array<Collection & { id: string }> | undefined = await firstValueFrom(ref.afterClosed().pipe(first()));

    if (!collections) {
      return false;
    }

    const createApis$ = (collections || [])
      .map((c) =>
        objects.map((objectId) => firstValueFrom(this.collectionItemApi.post(c.id, { objectId, className })))
      )
      .flat();

    await Promise.all(createApis$);

    this.snackBarService.open('Operazione avvenuta con successo', undefined, { duration: 4000 });
    return true;
  }
}
